import React, { FC } from "react";
import "./EmptyData.scss";

interface EmptyDataProps {
  title: string;
  description: string;
  disabled?: boolean;
  icon?: string;
  buttonTitle?: string;
  action?: () => void;
}

const EmptyData: FC<EmptyDataProps> = ({
  action,
  buttonTitle,
  description,
  icon,
  title,
  disabled,
}) => {
  return (
    <div className="empty-data">
      {icon && <img src={icon} alt="Empty data icon" />}
      <h4>{title}</h4>
      <p>{description}</p>
      {buttonTitle && action && (
        <button disabled={disabled} onClick={action}>
          {buttonTitle}
        </button>
      )}
    </div>
  );
};

export default EmptyData;
